import React from 'react';
import classNames from 'classnames';
import { Input, LocationAutoCompleteList, useT } from '@repo/common';
import { ReactComponent as LocationIcon } from '@repo/common/assets/icons/16px/icon_16px_location.svg';
import { useLocationSelection } from '@repo/common';

const StyledLocationIcon = ({ $state }) => (
  <LocationIcon
    className={classNames({
      'text-icon-primary': $state === 'active',
      'text-icon-placeholder': $state === 'default',
    })}
  />
);

const LocationInput = ({
  value,
  focused,
  inputRef,
  state,
  iconState,
  onChange,
  onFocus,
  onBlur,
  onSelect,
  onManualEnter,
  isMobile = false,
  isResume = false,
  isResumeCreate = false,
}) => {
  const t = useT();
  const {
    displayValue,
    handleFocus,
    handleChange,
    handleSelect,
    handleManualEnter,
    handleBlur,
  } = useLocationSelection({
    value,
    onChange,
    onFocus,
    onBlur,
    onSelect,
    onManualEnter,
  });

  return (
    <div className='relative'>
      <Input
        id='location-input'
        ref={inputRef}
        label={t('Location', '근무지')}
        placeholder={t('e.g. London, United Kingdom', '예: 런던, 영국')}
        value={displayValue}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        hideCount
        showStatusIcon={false}
        state={state}
        leftIcon={<StyledLocationIcon $state={iconState} />}
        className='placeholder:opacity-0 w-full'
      />
      {focused && displayValue.length >= 2 && (
        <div
          className={`${isResumeCreate ? 'relative w-full mt-1.5 z-10' : 'absolute left-0 right-0 z-10'}
          ${isResume ? 'top-[85px]' : !isResumeCreate && 'top-[56px]'}
        `}
        >
          <LocationAutoCompleteList
            searchText={displayValue}
            onSelect={handleSelect}
            onManualEnter={handleManualEnter}
            isMobile={isMobile}
            isResume={isResume}
          />
        </div>
      )}
    </div>
  );
};

export default LocationInput;
